import React from "react";
import type { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import type ChargesViewModel from "viewModels/callCenter/search/charges/chargesViewModel";
import type ChargeResponse from "entities/chargeResponse";
import Dropdown from "react-bootstrap/Dropdown";
import camelCase from "lodash/camelCase";
import Tooltip from "@edaz/edazkit/Tooltip";

export interface ChargeActionMenuProps {
  vm: ChargesViewModel;
  charge: ChargeResponse;
}

const ChargeActionMenu: FunctionComponent<ChargeActionMenuProps> = observer((props: ChargeActionMenuProps) => {
  const { vm, charge } = props;

  return (
    <Dropdown drop="left">
      <Dropdown.Toggle size="sm" variant="success" className="rounded caret-off">
        ⋮
      </Dropdown.Toggle>
      <Dropdown.Menu alignRight={true}>
        {vm.actions.map(action => {
          const allowed = vm[`allowTo${action}`](charge);
          let content: React.ReactNode = vm.translate(`actions.${camelCase(action)}.name`);
          if (!allowed) {
            content = (
              <Tooltip id={`charge-${charge.chargeId}-${action}`} tooltip={vm.disabledActionTooltip(action, charge)}>
                <span>{content}</span>
              </Tooltip>
            );
          }

          return (
            <Dropdown.Item
              key={action}
              disabled={!allowed}
              onClick={() => vm[`on${action}Click`](charge)}
              style={{ pointerEvents: "auto" }}>
              {content}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
});

export default ChargeActionMenu;
